export default __webpack_public_path__ + "static/media/Resources.633cc068.svg";